// extracted by mini-css-extract-plugin
export default {"saveOnChange":"styles-module__saveOnChange__src-labstep-web-core-Form-ShowEdit-Amount-_nZL03","header":"styles-module__header__src-labstep-web-core-Form-ShowEdit-Amount-_RSf9S"};